import { render, staticRenderFns } from "./orderTabFour.vue?vue&type=template&id=40665b2e&scoped=true"
import script from "./orderTabFour.vue?vue&type=script&lang=js"
export * from "./orderTabFour.vue?vue&type=script&lang=js"
import style1 from "./orderTabFour.vue?vue&type=style&index=1&id=40665b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40665b2e",
  null
  
)

export default component.exports